import React from "react";
import ReactTooltip from "react-tooltip";
import PropTypes from "prop-types";


const Tooltip = ({ id, place, text, offset, multiline,icon }) => {
  return (
    <div>
      <ReactTooltip id={id} place={place} offset={offset} multiline={multiline}>
        <div className="flex">
          <img src={icon}/>
          {text}
        </div>
      </ReactTooltip>
    </div>
  );
};

Tooltip.propTypes = {
  id: PropTypes.string.isRequired,
  place: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  offset: PropTypes.object.isRequired,
  multiline: PropTypes.bool.isRequired,
  icon:PropTypes.string
};

export default Tooltip;
